import { parsePhoneNumber } from "libphonenumber-js";
import actions from "./actions";

let contact, files, idx, file, addresses, contactPersons;

const initState = {
    types: [],
    contactCreateState: false,
    contactCreateResult: {},
    contactImportState: false,
    contactReadState: false,
    contactReadStatementState: false,
    contactReadAllState: false,
    contactUpdateState: false,
    contactUpdateResult: {},
    contactArchiveState: false,
    contactArchiveResult: {},
    deleteState: false,
    contactsMergeState: false,
    selectedContactIds: [],
    contactId: null, // for ContactPerson Select
    contacts: [],
    pagination: {},
    contact: {
        id: undefined,
        legal_name: undefined,
        other_name: undefined,
        reg_no_type: undefined,
        reg_no: undefined,
        old_reg_no: undefined,
        tax_id_no: undefined,
        sst_reg_no: undefined,
        contact_persons: [],
        types: [],
        receivable_account_id: undefined,
        debtor_credit_limit: undefined,
        payable_account_id: undefined,
        group_ids: [],
        price_level_id: undefined,
        entity_type: undefined,
        email: undefined,
        phone_no: undefined,
        addresses: [],
        default_currency_code: undefined,
        default_term_id: undefined,
        default_income_account_id: undefined,
        default_expense_account_id: undefined,
        default_myinvois_action: undefined,
        tag_ids: [],
        fields: [],
        receive_invoice_reminder: undefined,
        receive_monthly_statement: undefined,
        key: undefined,
        remarks: undefined,
        files: [],
        is_archived: undefined,
        mandate: undefined,
        created_at: undefined,
        updated_at: undefined,
    },
    contactMyInvoisFormFields: {
        legal_name: undefined,
        reg_no_type: undefined,
        reg_no: undefined,
        tax_id_no: undefined,
        phone_no_code: undefined,
        phone_no: undefined,
        entity_type: undefined,
        addresses: [],
    },
    addresses: [],
    addressesInitialNum: 0,
    contactPersons: [],
    billingContactPersonId: null,
    shippingContactPersonId: null,
    copyBillingAddress: false,
    statement: undefined,
    exportStatementState: false,
    statementWithRemarks: undefined, // s3 url
    sendEmailStatementState: false,
    statementType: undefined,
    shareStatementLinkState: false,
    shareStatementLink: undefined,

    sendMyInvoisInfoState: false,
    bulkSendMyInvoisInfoState: false,
    skippedIds: [],

    // bulk pdf
    createPdfsState: false,
    statementsPdf: undefined, // s3 url
    // bulk email
    sendBulkEmailStatementState: false,

    // bulk update contact
    readBulkContactsState: false,
    bulkContacts: [],
    bulkContactsPagination: {},
    bulkUpdateContactState: false,
    bulkUpdateContactResult: {},

    // mandates
    deleteMandateModalVisible: false,
    deleteMandateModalOverrideContact: {},
    mandateDrawerVisible: false,
    mandateDrawerMode: undefined, // 'create' or 'update'
    mandateDrawerOverrideContact: {},
    mandatesReadState: false,
    mandates: [],
    mandatesPagination: {},
    contactMandatesReadState: false,
    contactMandate: {},
    contactMandateCreateState: false,
    contactMandateUpdateState: false,
    contactMandateDeleteState: false,

    files: [],

    // To be removed
    createContactStatus: false,
    updateContactStatus: false,
    archiveContactSuccess: false,

    contactMyInvoisFields: {
        legal_name: false,
        reg_no: false,
        reg_no_type: false,
        tax_id_no: false,
        // entity_type: false,
        phone_no: false,
        phone_no_code: false,
    },
    contactMyInvoisAddressFields: {
        address: false,
    },

    tax_id_no: '',
    searchContactState: '',
    contactCodeLookupState: '',
    contactCodeLookupResult: {},
    forceHideFilePreview: false,

    importHeaderRowLineCount: 0,
    bulkDeleteContactsState: false,
    bulkDeleteContactsResult: {
        deletedCnt: 0,
        undeletableContacts: [],
    },
    bulkDeleteContactsError: "",
};

function generateKey() {
    return Math.random().toString(36);
}

export default function appReducer(state = initState, action = {}) {
    switch (action.type) {
        case actions.CONTACT_SET_TYPES:
            return {
                ...state,
                types: action.types,
            };
        case actions.CREATE_CONTACT_REQUEST:
            return {
                ...state,
                createContactStatus: "request", //
                contactCreateState: "request",
            };
        case actions.CREATE_CONTACT_SUCCESS:
            return {
                ...state,
                createContactStatus: "success", //
                contactCreateState: "success",
                contactCreateResult: action.contact,
            };
        case actions.CREATE_CONTACT_ERROR:
            return {
                ...state,
                createContactStatus: "error", //
                contactCreateState: "error",
            };
        case actions.READ_CONTACTS_REQUEST:
            return {
                ...state,
                contactReadAllState: "request",
            };
        case actions.READ_CONTACTS_SUCCESS:
            return {
                ...state,
                contactReadAllState: "success",
                contacts: action.contacts,
                pagination: {
                    total: action.pagination.total,
                    current: action.pagination.current_page,
                    pageSize: action.pagination.per_page,
                },
            };
        case actions.IMPORT_CONTACTS_REQUEST:
            return {
                ...state,
                contactImportState: "request",
            };
        case actions.IMPORT_CONTACTS_SUCCESS:
            return {
                ...state,
                contactImportState: "success",
            };
        case actions.BULK_UPDATE_CONTACTS_REQUEST:
            return {
                ...state,
                bulkUpdateContactState: "request",
                bulkUpdateContactErrors: null,
            };
        case actions.BULK_UPDATE_CONTACTS_SUCCESS:
            return {
                ...state,
                bulkUpdateContactState: "success",
                bulkUpdateContactResult: action.result,
                bulkUpdateContactErrors: null,
            };
        case actions.BULK_UPDATE_CONTACTS_ERROR:
            return {
                ...state,
                bulkUpdateContactState: "error",
                bulkUpdateContactErrors: action.errors || null,
            };
        case actions.BULK_DELETE_CONTACTS_REQUEST:
            return {
                ...state,
                bulkDeleteContactsState: "request",
            };
        case actions.BULK_DELETE_CONTACTS_SUCCESS:
            return {
                ...state,
                bulkDeleteContactsState: "success",
                bulkDeleteContactsResult: action.data,
            };
        case actions.BULK_DELETE_CONTACTS_ERROR:
            return {
                ...state,
                bulkDeleteContactsState: "error",
                bulkDeleteContactsError: action.error.message || "An error occurred while deleting contacts.",
            };
        case actions.READ_BULK_CONTACTS_REQUEST:
            return {
                ...state,
                readBulkContactsState: "request",
            };
        case actions.READ_BULK_CONTACTS_SUCCESS:
            return {
                ...state,
                readBulkContactsState: "success",
                bulkContacts: action.contacts,
                bulkContactsPagination: {
                    total: action.pagination.total,
                    current: action.pagination.current_page,
                    pageSize: action.pagination.per_page,
                },
            };
        case actions.READ_BULK_CONTACTS_ERROR:
            return {
                ...state,
                readBulkContactsState: "error",
            };
        case actions.READ_CONTACT_REQUEST:
            return {
                ...state,
                contactReadState: "request",
            };
        case actions.READ_CONTACT_SUCCESS: {
            const { contact, forceHideFilePreview } = action;

            // parse phone number
            let countryCallingCode, nationalNumber;
            if (contact.phone_no) {
                const firstPhoneNum = contact.phone_no.split(",")[0];
                try {
                    ({ countryCallingCode, nationalNumber } = parsePhoneNumber(
                        `+${firstPhoneNum}`,
                    ));
                }
                catch (err) {
                    //
                }
            }

            contact.addresses = contact.addresses.map(address => {
                const newAddress = { ...address };
                if (!newAddress.key)
                    newAddress.key = generateKey();

                return newAddress;
            });

            contact.contact_persons = contact.contact_persons.map(cp => {
                const newContactPerson = { ...cp };
                if (!newContactPerson.key)
                    newContactPerson.key = generateKey();

                return newContactPerson;
            });

            const defaultBillingAddress = contact?.addresses?.find(
                add => add.is_default_billing,
            );

            // if (!defaultBillingAddress)
            //     return {address: false};

            return {
                ...state,
                contactReadState: "success",
                contact,
                addresses: JSON.parse(JSON.stringify(contact.addresses)),
                addressesInitialNum: contact.addresses.length,
                contactPersons: JSON.parse(JSON.stringify(contact.contact_persons)),
                contactMyInvoisFormFields: {
                    legal_name: contact.legal_name,
                    reg_no: contact.reg_no,
                    reg_no_type: contact.reg_no_type,
                    tax_id_no: contact.tax_id_no,
                    entity_type: contact.entity_type,
                    phone_no: nationalNumber || contact.phone_no,
                    phone_no_code: countryCallingCode || contact.phone_no_code,
                    addresses: contact.addresses,
                },
                types: contact.types,
                files: contact.files || [],
                contactMyInvoisFields: {
                    legal_name: contact.legal_name,
                    reg_no: contact.reg_no,
                    reg_no_type: contact.reg_no_type,
                    tax_id_no: contact.tax_id_no,
                    entity_type: contact.entity_type,
                    phone_no: nationalNumber || contact.phone_no,
                    phone_no_code: countryCallingCode || contact.phone_no_code,
                    // addresses: contact.addresses,
                },
                contactMyInvoisAddressFields: !defaultBillingAddress
                    ? { address: false }
                    : {
                        address: true,
                        // name: defaultBillingAddress.name,
                        street: defaultBillingAddress.street,
                        city: defaultBillingAddress.city,
                        state: defaultBillingAddress.state,
                        country_code: defaultBillingAddress.country_code,
                    },
                forceHideFilePreview,
            };
        }
        case actions.SET_BILLING_CONTACT_PERSON_ID:
            return {
                ...state,
                billingContactPersonId: action.id,
            };
        case actions.SET_SHIPPING_CONTACT_PERSON_ID:
            return {
                ...state,
                shippingContactPersonId: action.id,
            };
        case actions.READ_CONTACT_STATEMENT_REQUEST:
            return {
                ...state,
                contactReadStatementState: "request",
            };
        case actions.READ_CONTACT_STATEMENT_SUCCESS:
            return {
                ...state,
                contactReadStatementState: "success",
                statement: action.statement,
                contactId: action.contact.id,
            };
        case actions.UPDATE_CONTACT_REQUEST:
            return {
                ...state,
                updateContactStatus: "request", //
                contactUpdateState: "request",
            };
        case actions.UPDATE_CONTACT_SUCCESS:
            return {
                ...state,
                updateContactStatus: "success", //
                contactUpdateState: "success",
                contactUpdateResult: action.contact,
            };
        case actions.UPDATE_CONTACT_MYINVOIS_FORM_FIELD:
        // field and value is from the action
            return {
                ...state,
                contactMyInvoisFormFields: {
                    ...state.contactMyInvoisFormFields,
                    [action.field]: action.value,
                },
            };
        case actions.ARCHIVE_CONTACT_REQUEST:
            return {
                ...state,
                contactArchiveState: "request",
                archiveContactSuccess: false, //
            };
        case actions.ARCHIVE_CONTACT_SUCCESS:
            return {
                ...state,
                contactArchiveState: "success",
                contactArchiveResult: action.contact,
                archiveContactSuccess: true, //
            };
        case actions.DELETE_CONTACT_REQUEST:
            return {
                ...state,
                deleteState: "request",
            };
        case actions.DELETE_CONTACT_SUCCESS:
            return {
                ...state,
                deleteState: "success",
            };
        case actions.CHANGE_CONTACT: // Partial update
            contact = {
                ...(action.reset ? initState.contact : state.contact),
                ...action.request,
            };

            return {
                ...state,
                contact,
                types: contact.types,
            };
        case actions.RESET_CONTACT_STATE:
            return {
                ...initState,
            };
        case actions.SEND_EMAIL_STATEMENT_REQUEST:
            return {
                ...state,
                sendEmailStatementState: "request",
            };
        case actions.SEND_EMAIL_STATEMENT_SUCCESS:
            return {
                ...state,
                sendEmailStatementState: "success",
            };
        case actions.SEND_EMAIL_STATEMENT_ERROR:
            return {
                ...state,
                sendEmailStatementState: false,
            };
        case actions.CONTACT_ADD_FILE: // Add to the end of the list
            return {
                ...state,
                files: [...state.files, action.file],
            };
        case actions.CONTACT_SET_FILE: // Support partial update (Must have file_id)
            files = [...state.files];
            idx = files.findIndex(item => item.file_id === action.file.file_id);

            // Merge the file
            file = {
                ...files[idx],
                ...action.file,
            };

            // Merge back to files
            files[idx] = file;

            return {
                ...state,
                files,
            };
        case actions.CONTACT_SET_FILES:
            return {
                ...state,
                files: action.files,
            };
        case actions.CONTACT_REMOVE_FILE: // Delete from the list
            files = [...state.files];
            idx = files.findIndex(item => item.file_id === action.fileId);
            files.splice(idx, 1);

            return {
                ...state,
                files,
            };
            // view pdf
        case actions.EXPORT_STATEMENT_REQUEST:
            return {
                ...state,
                exportStatementState: "request",
            };
        case actions.EXPORT_STATEMENT_SUCCESS:
            return {
                ...state,
                exportStatementState: "success",
                statementWithRemarks: action.statementWithRemarks,
            };
        case actions.EXPORT_STATEMENT_ERROR:
            return {
                ...state,
                exportStatementState: false,
            };

            // bulk view pdfs
        case actions.CREATE_PDFS_REQUEST:
            return {
                ...state,
                createPdfsState: "request",
            };
        case actions.CREATE_PDFS_SUCCESS:
            return {
                ...state,
                createPdfsState: "success",
                statementsPdf: action.statementsPdf,
            };
        case actions.CREATE_PDFS_ERROR:
            return {
                ...state,
                createPdfsState: "error",
            };
            // bulk send email
        case actions.SEND_BULK_EMAIL_STATEMENT_REQUEST:
            return {
                ...state,
                sendBulkEmailStatementState: "request",
            };
        case actions.SEND_BULK_EMAIL_STATEMENT_SUCCESS:
            return {
                ...state,
                sendBulkEmailStatementState: "success",
            };
        case actions.SEND_BULK_EMAIL_STATEMENT_ERROR:
            return {
                ...state,
                sendBulkEmailStatementState: "error",
            };

            // view pdf
        case actions.GET_STATEMENT_LINK_REQUEST:
            return {
                ...state,
                shareStatementLinkState: "request",
            };
        case actions.GET_STATEMENT_LINK_SUCCESS:
            return {
                ...state,
                shareStatementLinkState: "success",
                shareStatementLink: action.shareStatementLink,
            };
        case actions.GET_STATEMENT_LINK_ERROR:
            return {
                ...state,
                shareStatementLinkState: false,
            };

        case actions.SET_CONTACT_STATEMENT_TYPE:
            return {
                ...state,
                statementType: action.statementType,
            };

        case actions.CONTACTS_MERGE_REQUEST:
            return {
                ...state,
                contactsMergeState: "request",
            };
        case actions.CONTACTS_MERGE_SUCCESS:
            return {
                ...state,
                contactsMergeState: "success",
            };
        case actions.CONTACTS_MERGE_ERROR:
            return {
                ...state,
                contactsMergeState: "error",
            };
        case actions.SEND_MYINVOIS_INFO_REQUEST:
            return {
                ...state,
                sendMyInvoisInfoState: "request",
            };
        case actions.SEND_MYINVOIS_INFO_SUCCESS:
            return {
                ...state,
                sendMyInvoisInfoState: "success",
            };
        case actions.SEND_MYINVOIS_INFO_ERROR:
            return {
                ...state,
                sendMyInvoisInfoState: "error",
            };
        case actions.GET_MYINVOIS_INFO_REQUEST:
            return {
                ...state,
                getMyInvoisInfoState: "request",
            };
        case actions.GET_MYINVOIS_INFO_SUCCESS:
            return {
                ...state,
                myInvoisRequestInfoLink: action.link,
                getMyInvoisInfoState: "success",
            };
        case actions.GET_MYINVOIS_INFO_ERROR:
            return {
                ...state,
                getMyInvoisInfoState: "error",
            };
        case actions.BULK_SEND_MYINVOIS_INFO_REQUEST:
            return {
                ...state,
                bulkSendMyInvoisInfoState: "request",
            };
        case actions.BULK_SEND_MYINVOIS_INFO_SUCCESS:
            return {
                ...state,
                bulkSendMyInvoisInfoState: "success",
                skippedIds: action.skippedIds,
            };
        case actions.BULK_SEND_MYINVOIS_INFO_ERROR:
            return {
                ...state,
                bulkSendMyInvoisInfoState: "error",
            };

            // MANDATE
        case actions.TOGGLE_MANDATE_MODAL:
            return {
                ...state,
                deleteMandateModalVisible: action.visible,
                deleteMandateModalOverrideContact: action.overrideContact,
            };
        case actions.TOGGLE_MANDATE_DRAWER:
            return {
                ...state,
                mandateDrawerVisible: action.visible,
                mandateDrawerMode: action.mode,
                mandateDrawerOverrideContact: action.overrideContact,
            };
        case actions.GET_MANDATES_REQUEST:
            return {
                ...state,
                mandatesReadState: "request",
            };
        case actions.GET_MANDATES_SUCCESS: {
            const { mandates } = action;
            return {
                ...state,
                mandatesReadState: "success",
                mandates,
                mandatesPagination: {
                    total: action.pagination.total,
                    current: action.pagination.current_page,
                    pageSize: action.pagination.per_page,
                },
            };
        }
        case actions.READ_CONTACT_MANDATE_REQUEST:
            return {
                ...state,
                contactMandatesReadState: "request",
            };
        case actions.READ_CONTACT_MANDATE_SUCCESS: {
            const { mandate } = action;

            return {
                ...state,
                contactMandatesReadState: "success",
                contactMandate: mandate,
            };
        }
        case actions.CREATE_CONTACT_MANDATE_REQUEST:
            return {
                ...state,
                contactMandateCreateState: "request",
            };
        case actions.CREATE_CONTACT_MANDATE_SUCCESS: {
            return {
                ...state,
                contactMandateCreateState: "success",
                // contactMandate: mandates,
            };
        }
        case actions.UPDATE_CONTACT_MANDATE_REQUEST:
            return {
                ...state,
                contactMandateUpdateState: "request",
            };
        case actions.UPDATE_CONTACT_MANDATE_SUCCESS: {
            return {
                ...state,
                contactMandateUpdateState: "success",
            };
        }
        case actions.DELETE_CONTACT_MANDATE_REQUEST:
            return {
                ...state,
                contactMandateDeleteState: "request",
            };
        case actions.DELETE_CONTACT_MANDATE_SUCCESS: {
            return {
                ...state,
                contactMandateDeleteState: "success",
            };
        }
        case actions.DELETE_CONTACT_MANDATE_ERROR: {
            return {
                ...state,
                contactMandateDeleteState: "error",
            };
        }

        case actions.CONTACT_SET_TABLE_IDS:
            return {
                ...state,
                selectedContactIds: action.ids,
            };

        case actions.ADD_ADDRESS:
            return {
                ...state,
                addressesInitialNum: state.addressesInitialNum + 1,
                addresses: [
                    ...state.addresses,
                    {
                        key: generateKey(),
                        name: `Address ${state.addressesInitialNum + 1}`,
                    },
                ],
            };

        case actions.SET_ALL_ADDRESS:
            return {
                ...state,
                addresses: [...action.addresses],
            };

        case actions.DELETE_ADDRESS: {
            addresses = [...state.addresses];
            idx = addresses.findIndex(address => address.key === action.key);
            addresses.splice(idx, 1);
            let currentAddressesInitialNum;
            if (idx === addresses.length - 1)
                currentAddressesInitialNum = state.addressesInitialNum;
            else if (state.addressesInitialNum > 0)
                currentAddressesInitialNum = state.addressesInitialNum - 1;
            else
                currentAddressesInitialNum = 0;

            return {
                ...state,
                // if last address - keep the counter, dont decrement
                // else decrement, but not below 0
                // eslint-disable-next-line no-nested-ternary
                addressesInitialNum: currentAddressesInitialNum,
                addresses,
            };
        }
        case actions.RESET_ALL_ADDRESS:
            return {
                ...state,
                addresses: [...initState.addresses],
            };

        case actions.ADD_CONTACT_PERSON:
            return {
                ...state,
                contactPersons: [...state.contactPersons, { key: generateKey() }],
            };

        case actions.SET_ALL_CONTACT_PERSON:
            return {
                ...state,
                contactPersons: [...action.contactPersons],
            };

        case actions.REMOVE_CONTACT_PERSON:
            contactPersons = [...state.contactPersons];
            idx = contactPersons.findIndex(cp => cp.key === action.key);
            contactPersons.splice(idx, 1);
            return {
                ...state,
                contactPersons,
            };

        case actions.RESET_ALL_CONTACT_PERSON:
            return {
                ...state,
                contactPersons: [...initState.contactPersons],
            };

        case actions.SET_CONTACT_MYINVOIS_FIELD:
            return {
                ...state,
                contactMyInvoisFields: {
                    ...state.contactMyInvoisFields,
                    [action.key]: action.value,
                },
            };
        case actions.SET_CONTACT_MYINVOIS_FIELDS:
            return {
                ...state,
                contactMyInvoisFields: {
                    ...state.contactMyInvoisFields,
                    ...action.updatedValues,
                },
            };
        case actions.SET_CONTACT_MYINVOIS_ADDRESSS_FIELD: // for default billing address
            return {
                ...state,
                contactMyInvoisAddressFields: {
                    ...state.contactMyInvoisAddressFields,
                    address: true, // since now we already have a default billing address, set 'address' to true
                    [action.key]: action.value,
                },
            };
        case actions.RESET_CONTACT_MYINVOIS_ADDRESS_FIELDS: // for default billing address
            return {
                ...state,
                contactMyInvoisAddressFields: {
                    // wipe all other fields (street, state etc.)
                    address: action.hasDefaultAddress,
                    ...action.values,
                },
            };
        case actions.SEARCH_CONTACT_TIN_REQUEST:
            return {
                ...state,
                searchContactState: "request",
            };
        case actions.SEARCH_CONTACT_TIN_SUCCESS:
            return {
                ...state,
                searchContactState: "success",
                tax_id_no: action.tin,
            };
        case actions.SEARCH_CONTACT_TIN_ERROR:
            return {
                ...state,
                searchContactState: "error",
            };
        case actions.GET_CONTACT_CODE_REQUEST:
            return {
                ...state,
                contactCodeLookupState: "request",
            };
        case actions.GET_CONTACT_CODE_SUCCESS:
            return {
                ...state,
                contactCodeLookupState: "success",
                contactCodeLookupResult: {
                    contact_code: action.contact_code,
                },
            };
        case actions.GET_CONTACT_CODE_ERROR:
            return {
                ...state,
                contactCodeLookupState: "error",
            };
        case actions.SET_CONTACT_FIELD:
            return {
                ...state,
                contact: {
                    ...state.contact,
                    [action.key]: action.value,
                },
            };
        case actions.SET_CONTACT_ID:
            return {
                ...state,
                contactId: action.contactId,
            };

        case actions.SET_IMPORT_HEADER_ROW_LINE_COUNT:
            return {
                ...state,
                importHeaderRowLineCount: action.count,
            };
        default:
            return state;
    }
}
